export default __webpack_public_path__ + "static/generator_symbol_b.1aa965fe047a407e61b3820c3952bf05.svg";